// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1mpxF","location":"Header_location__1Fn75"};